import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { AuthModal } from "./Auth";
import { useNavigate } from "react-router";
import { UserApi } from "../api-services/user.api";

export default function Header({ page=1 }) 
{
  const navigate = useNavigate();
  const [state, setState] = useState(true);
  const [isAuthContainerVisible, setisAuthContainerVisible] = useState(false);

  const user = UserApi(); 

  const signout = ()=> {
      user.logout();
      localStorage.clear();
      navigate('/');
  }

  return (
    <>
      {
        state && (
          <div className="bg-dark text-white text-center py-2 position-relative border-grays z-index-md">
            {
                localStorage.getItem('token') ? (
                  <div className="fw-bold d-flex align-items-center justify-content-center gap-2">
                    <i className="bi bi-leaf text-success"></i>
                    <span className="text-success">Agrospace</span> <span className="hidden-sm"> | <TextReducer text={ localStorage.getItem('fname') + ' ' + localStorage.getItem('lname') }  maxsize={15} />   </span>  
                    <a className="ms-2 nav-links" href="/">
                      <i className="bi bi-arrow-right text-light"></i>
                    </a> 
                  </div>
                ) : (
                  
                  <div className="fw-bold d-flex align-items-center justify-content-center gap-2">
                    <i className="bi bi-leaf text-success"></i>
                    <span className="text-success">Agrospace</span> <span className="hidden-sm">vous souhaite la bienvenue </span> 
                    <i className="bi bi-arrow-right"></i>
                  </div>
                ) 
            }
            
            <button className="btn-close btn-close-white position-absolute end-0 me-3" style={{ top: "10px" }} aria-label="Close" onClick={()=> setState(false) } ></button>
          </div>
        )
      }

      {
        isAuthContainerVisible && ( <AuthModal method={ ()=> setisAuthContainerVisible(false) } /> )
      }

      {/* Bandeau supérieur */}
      <div className="bg-dark text-white text-center py-2 position-relative px-4 z-index-md">
        <div className="d-flex justify-content-end align-items-center gap-4">
          <a className={`nav-link ${(page===6) && 'text-success'}`} href="/condition-utilisation">Condition d'utilisation </a>
          <a className={`nav-link ${(page===7) && 'text-success'}`} href="/contact">Contacts </a>
        </div> 
      </div>

      {/* Navbar principale */}
      <nav className="navbar navbar-expand-lg bg-white shadow-sm sticky-top">
        <div className="container-fluid py-2">
          {/* Logo */}
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img src="../favicon.png" alt="icon-agrospace" width="30" className="me-2"/>
            <span className="text-green fs-5">  Agrospace </span>
          </a>

          {/* Burger menu pour mobile */}
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          
          {/* Liens */}
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item mx-2">
                <a className={`nav-link ${(page===1) && 'text-success'}`} href="/"> <i className="bi bi-plus-circle"></i> Accueil </a>
              </li>
              <li className="nav-item mx-2">
                <a className={`nav-link ${(page===2) && 'text-success'}`} href="/produits"> <i className="bi bi-plus-circle"></i> Produits</a>
              </li>
              <li className="nav-item mx-2">
                <a className={`nav-link ${(page===3) && 'text-success'}`} href="/tarifs"> <i className="bi bi-plus-circle"></i> Tarifs freemium</a>
              </li>
              <li className="nav-item mx-2">
                <a className={`nav-link ${(page===4) && 'text-success'}`} href="/support"> <i className="bi bi-plus-circle"></i> Support</a>
              </li>
              <li className="nav-item mx-2">
                <a className={`nav-link ${(page===5) && 'text-success'}`} href="/partenariats"> <i className="bi bi-plus-circle"></i> Partenariats</a>
              </li>
            </ul>

            {/* Actions à droite */}
            <div className="d-flex align-items-center">
              <a className="btn btn-outline-dark me-2" href="/inscription"> S'inscrire </a>
              {
                localStorage.getItem('token') ? 
                ( <button className="btn btn-success" type="button" onClick={ signout } > Se-déconnecter </button> ) :
                ( <button className="btn btn-success" type="button" onClick={ ()=> setisAuthContainerVisible(true) } > Se-connecter </button> ) 
              }
              
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}




export function TextReducer({text, maxsize}) 
{
    if ( text?.length <= maxsize )
     return ( <span > { text }  </span> )
    else{
        const reducer = text?.slice(0, maxsize) + '...';
        return ( <span > { reducer }  </span> )
    }
}
